import { BaseApiService } from './BaseApiService';
import { sharedTokenRefresh } from './tokenRefresh';
import { ScreenshotResult } from './ScreenshotService';

export interface HelpRequest {
    message: string;
    screenshotBase64?: string;
    userAgent: string;
    platform: string;
    language: string;
    screenResolution: string;
    viewportSize: string;
    url: string;
}

export interface HelpResponse {
    success: boolean;
    message: string;
}

/**
 * Service for sending help requests
 */
export class HelpApiService extends BaseApiService {
    constructor() {
        super(sharedTokenRefresh);
    }

    /**
     * Send a help request with optional screenshot
     */
    async sendHelpRequest(
        message: string,
        includeScreenshot: boolean,
        screenshot?: ScreenshotResult
    ): Promise<HelpResponse> {
        const browserInfo = this.getBrowserInfo();

        const request: HelpRequest = {
            message,
            userAgent: browserInfo.userAgent,
            platform: browserInfo.platform,
            language: browserInfo.language,
            screenResolution: browserInfo.screenResolution,
            viewportSize: browserInfo.viewportSize,
            url: browserInfo.url,
            ...(includeScreenshot && screenshot && {
                screenshotBase64: screenshot.dataUrl
            })
        };

        const response = await this.postJson('/v1/help/request', request);

        return await this.handleResponse<HelpResponse>(response);
    }

    /**
     * Get browser information for help requests
     */
    private getBrowserInfo() {
        return {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            language: navigator.language,
            screenResolution: `${screen.width}x${screen.height}`,
            viewportSize: `${window.innerWidth}x${window.innerHeight}`,
            url: window.location.href,
        };
    }
}

// Export a singleton instance
export const helpApiService = new HelpApiService();
